import { render, staticRenderFns } from "./BpCashBankRatioDisplayer.vue?vue&type=template&id=0ce958f7"
import script from "./BpCashBankRatioDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpCashBankRatioDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports